import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMarketPrice, MarketPriceResponse } from '../../../api/v1/market'
import { TradeType } from '../types'
import { SymbolId } from '../../../types'
import { RootState } from '../../index'
import { OrderDirection } from '../../spot/types'

export const getMarketPriceAction = createAsyncThunk<
  MarketPriceResponse,
  { tradeType: TradeType; symbolId: SymbolId },
  {
    state: RootState
  }
>(
  'market/getMarketPriceAction',
  async ({ tradeType, symbolId }, { getState }) => {
    const state = getState()
    const { accountInfo } = state.account
    if (!accountInfo?.userId)
      return {
        SHORT: {},
        LONG: {},
      }

    const r = await getMarketPrice(tradeType, [
      {
        symbolId,
        direction: OrderDirection.LONG,
      },
      {
        symbolId,
        direction: OrderDirection.SHORT,
      },
    ])
    return r.data
  }
)
